import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { AppContext } from '../context';
import { Info, InfoBar, Flexed, NormalFlex } from './jumbotron-styled';
import {
  BaSeHeading3,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';

const showInfo = (text) => text?.substr(0, 30);

export const Jumbotron = ({ title, complement, moreInfo, updateScreen }) => {
  const { empresa } = React.useContext(AppContext);

  const maskedCnpj = Sebrae.useMask(empresa?.cnpj, 'cnpj');
  return (
    <Flexed>
      <Info>
        <BaSeHeading3
          isBold
          color={BaSeTheme.colors.institucionais.azulSebrae36}
        >
          {title}
        </BaSeHeading3>
        <InfoBar />{' '}
        <BaSeSmall1
          isBold
          color={BaSeTheme.colors.institucionais.cinzaSebrae45}
        >
          {showInfo(
            (empresa?.apelido ?? empresa?.nome) || empresa?.razaoSocial,
          )}
        </BaSeSmall1>
        {!!moreInfo && (
          <>
            <InfoBar />{' '}
            <BaSeSmall1
              isBold
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              {showInfo(maskedCnpj)}
            </BaSeSmall1>
          </>
        )}
      </Info>
      <NormalFlex>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
          {complement}
        </BaSeParagraph>
        {!!updateScreen && updateScreen?.()}
      </NormalFlex>
    </Flexed>
  );
};
